import { render, staticRenderFns } from "./ProductSearchResult.vue?vue&type=template&id=3601573e"
import script from "./ProductSearchResult.vue?vue&type=script&lang=js"
export * from "./ProductSearchResult.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchResult.vue?vue&type=style&index=0&id=3601573e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports